import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "KSearchWidget";
var classes = {
    background: "".concat(PREFIX, "-background"),
    container: "".concat(PREFIX, "-container"),
    search: "".concat(PREFIX, "-search")
};
var StyledKSearchWidget = styled(Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            width: "100%",
            padding: theme.spacing(1),
            borderRadius: theme.shape.borderRadius,
            position: "relative",
            backgroundColor: theme.palette.grey[900]
        },
        _b["& .".concat(classes.background)] = {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover"
        },
        _b["& .".concat(classes.container)] = {
            zIndex: 2
        },
        _b["& .".concat(classes.search)] = {
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1)
        },
        _b);
});

export { classes, StyledKSearchWidget as default };
//# sourceMappingURL=index.styled.js.map
